import React from 'react';
import { useLoadScript } from '@react-google-maps/api';

import PageLayout from '../../components/PageLayout';
import MyZone from '../../components/master/Zone';

interface MasterPageProps {
  onLogout?: () => void;
  currentPage?: string;
  onNavigate?: (page: string) => void;
}

const ZonePage: React.FC<MasterPageProps> = ({ onLogout, currentPage, onNavigate }) => {

  return (
    <PageLayout onLogout={onLogout} currentPage={currentPage} onNavigate={onNavigate}>
      <MyZone />
    </PageLayout>
  );
};

export default ZonePage;
